import { defineComponent as r, computed as c, openBlock as l, createElementBlock as h, createElementVNode as e, toDisplayString as n, createCommentVNode as d, normalizeStyle as v } from "vue";
const f = ["viewBox"], _ = /* @__PURE__ */ e("mask", { id: "71af516c-3fd5-4b9d-bfa5-4e4362027d77" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#71af516c-3fd5-4b9d-bfa5-4e4362027d77)" }, u = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M304 0h208v208l-32 48 32 48v208H304l-48-32-48 32H0V304Z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0v304h208v208h96V304h208v-96H304V0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M120 27a23 23 0 0 0-23 23v16h-9v-9c0-10-8-18-18-18-2 0-4 2-4 4v42c0 2 2 4 4 4h27a21 21 0 0 0 21 22v9h-8c-11 0-19 8-19 18 0 3 2 5 5 5h41c3 0 5-2 5-5v-28h57v9h-9c-10 0-18 8-18 18 0 2 2 4 4 4h42c2 0 4-2 4-4V82c9 0 16-7 16-16s-7-16-16-16h-54c-3 0-5-2-5-5s2-6 5-6h54V29h-54c-8 0-16 7-16 16 0 8 8 16 16 16h54c3 0 6 2 6 5s-3 5-6 5h-58c-12 0-22-9-22-21a23 23 0 0 0-22-23zm0 135a23 23 0 0 0-23 23v16h-9v-9c0-10-8-18-18-18-2 0-4 2-4 4v42c0 2 2 4 4 4h27a21 21 0 0 0 21 22v9h-8c-11 0-19 8-19 18 0 3 2 5 5 5h41c3 0 5-2 5-5v-28h57v9h-9c-10 0-18 8-18 18 0 2 2 4 4 4h42c2 0 4-2 4-4v-55c9 0 16-7 16-16s-7-16-16-16h-54c-3 0-5-2-5-5s2-6 5-6h54v-10h-54c-8 0-16 7-16 16 0 8 8 16 16 16h54c3 0 6 2 6 5s-3 5-6 5h-58c-12 0-22-9-22-21a23 23 0 0 0-22-23z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ r({
  __name: "cq",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, o = c(() => 512 + 2 * t.strokeWidth), s = c(() => -t.strokeWidth), i = c(() => 256 + t.strokeWidth / 2);
    return (V, y) => (l(), h("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      _,
      e("g", m, [
        t.flagName ? (l(), h("title", u, n(t.flagName), 1)) : d("", !0),
        k,
        p,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: v({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=cq-e8d392a1.js.map
